import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useRole } from '../context/roleContext';

const ProtectedRoute = ({ children, onlyAdmins = false, onlySupport = false }) => {
  const { currentUser } = useAuth();
  const { role, loading } = useRole();
  
  //console.log("ProtectedRoute - User:", currentUser);
  // console.log("ProtectedRoute - Role:", role);
  // console.log("ProtectedRoute - currentUser", currentUser);
  // console.log("ProtectedRoute - loading", loading);

  if (loading) {
    return <div className='large-top-margin'>Carregando permissões...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (onlyAdmins && role !== 'admin') {
    return <Navigate to="/suporte" />;
  }

  if (onlySupport && role !== 'support') {
    return <Navigate to="/user-area" />;
  }

  return children;
};

export default ProtectedRoute;
